import { useMediaQuery } from 'shared/hooks/dom';

export const useMaxItems = (maxItems: number) => {
  const matches = useMediaQuery('sm', 'down');

  return matches ? maxItems : undefined;
};
